__turbopack_context__.v({
  "IncardSection": "HolidayDetail-module__MbRGWq__IncardSection",
  "accentBar": "HolidayDetail-module__MbRGWq__accentBar",
  "actions": "HolidayDetail-module__MbRGWq__actions",
  "badge": "HolidayDetail-module__MbRGWq__badge",
  "bodyLayout": "HolidayDetail-module__MbRGWq__bodyLayout",
  "cardBody": "HolidayDetail-module__MbRGWq__cardBody",
  "cardHeader": "HolidayDetail-module__MbRGWq__cardHeader",
  "cardHeaderStatic": "HolidayDetail-module__MbRGWq__cardHeaderStatic",
  "cardSection": "HolidayDetail-module__MbRGWq__cardSection",
  "cardTitle": "HolidayDetail-module__MbRGWq__cardTitle",
  "carouselDots": "HolidayDetail-module__MbRGWq__carouselDots",
  "carouselImg": "HolidayDetail-module__MbRGWq__carouselImg",
  "carouselImgWrap": "HolidayDetail-module__MbRGWq__carouselImgWrap",
  "carouselNav": "HolidayDetail-module__MbRGWq__carouselNav",
  "carouselNext": "HolidayDetail-module__MbRGWq__carouselNext",
  "carouselPrev": "HolidayDetail-module__MbRGWq__carouselPrev",
  "carouselSlide": "HolidayDetail-module__MbRGWq__carouselSlide",
  "carouselWrap": "HolidayDetail-module__MbRGWq__carouselWrap",
  "carouselWrapSingle": "HolidayDetail-module__MbRGWq__carouselWrapSingle",
  "chevronOpen": "HolidayDetail-module__MbRGWq__chevronOpen",
  "columnAfterDuration": "HolidayDetail-module__MbRGWq__columnAfterDuration",
  "dayBadge": "HolidayDetail-module__MbRGWq__dayBadge",
  "dayBody": "HolidayDetail-module__MbRGWq__dayBody",
  "dayDesc": "HolidayDetail-module__MbRGWq__dayDesc",
  "dayHead": "HolidayDetail-module__MbRGWq__dayHead",
  "dayIncIcon": "HolidayDetail-module__MbRGWq__dayIncIcon",
  "dayItem": "HolidayDetail-module__MbRGWq__dayItem",
  "dayList": "HolidayDetail-module__MbRGWq__dayList",
  "dayTitle": "HolidayDetail-module__MbRGWq__dayTitle",
  "desktopActionCards": "HolidayDetail-module__MbRGWq__desktopActionCards",
  "desktopInclusions": "HolidayDetail-module__MbRGWq__desktopInclusions",
  "desktopSidebarPrice": "HolidayDetail-module__MbRGWq__desktopSidebarPrice",
  "desktopTabLabel": "HolidayDetail-module__MbRGWq__desktopTabLabel",
  "durationBadge": "HolidayDetail-module__MbRGWq__durationBadge",
  "durationHead": "HolidayDetail-module__MbRGWq__durationHead",
  "durationRow": "HolidayDetail-module__MbRGWq__durationRow",
  "enquiryBtn": "HolidayDetail-module__MbRGWq__enquiryBtn",
  "errorMsg": "HolidayDetail-module__MbRGWq__errorMsg",
  "featureRow": "HolidayDetail-module__MbRGWq__featureRow",
  "featureRowInner": "HolidayDetail-module__MbRGWq__featureRowInner",
  "flightInclusion": "HolidayDetail-module__MbRGWq__flightInclusion",
  "flightSubTextTip": "HolidayDetail-module__MbRGWq__flightSubTextTip",
  "galleryDesktop": "HolidayDetail-module__MbRGWq__galleryDesktop",
  "galleryMobile": "HolidayDetail-module__MbRGWq__galleryMobile",
  "galleryNav": "HolidayDetail-module__MbRGWq__galleryNav",
  "galleryNavNext": "HolidayDetail-module__MbRGWq__galleryNavNext",
  "galleryNavPrev": "HolidayDetail-module__MbRGWq__galleryNavPrev",
  "gallerySliderSlide": "HolidayDetail-module__MbRGWq__gallerySliderSlide",
  "gallerySliderWrap": "HolidayDetail-module__MbRGWq__gallerySliderWrap",
  "headerFooter": "HolidayDetail-module__MbRGWq__headerFooter",
  "heroActions": "HolidayDetail-module__MbRGWq__heroActions",
  "heroDesktop": "HolidayDetail-module__MbRGWq__heroDesktop",
  "heroMobile": "HolidayDetail-module__MbRGWq__heroMobile",
  "heroTopRow": "HolidayDetail-module__MbRGWq__heroTopRow",
  "hotelCard": "HolidayDetail-module__MbRGWq__hotelCard",
  "hotelCardMobile": "HolidayDetail-module__MbRGWq__hotelCardMobile",
  "hotelCardTop": "HolidayDetail-module__MbRGWq__hotelCardTop",
  "hotelImage": "HolidayDetail-module__MbRGWq__hotelImage",
  "hotelList": "HolidayDetail-module__MbRGWq__hotelList",
  "hotelName": "HolidayDetail-module__MbRGWq__hotelName",
  "hotelSelectButton": "HolidayDetail-module__MbRGWq__hotelSelectButton",
  "hoteldetails": "HolidayDetail-module__MbRGWq__hoteldetails",
  "iconBtn": "HolidayDetail-module__MbRGWq__iconBtn",
  "ieCard": "HolidayDetail-module__MbRGWq__ieCard",
  "ieCardDiv": "HolidayDetail-module__MbRGWq__ieCardDiv",
  "ieGrid": "HolidayDetail-module__MbRGWq__ieGrid",
  "ieIcon": "HolidayDetail-module__MbRGWq__ieIcon",
  "ieNo": "HolidayDetail-module__MbRGWq__ieNo",
  "ieYes": "HolidayDetail-module__MbRGWq__ieYes",
  "inclusionItem": "HolidayDetail-module__MbRGWq__inclusionItem",
  "inclusionItemIcon": "HolidayDetail-module__MbRGWq__inclusionItemIcon",
  "inclusionsBox": "HolidayDetail-module__MbRGWq__inclusionsBox",
  "inclusionsGrid": "HolidayDetail-module__MbRGWq__inclusionsGrid",
  "inclusionsGridWithTip": "HolidayDetail-module__MbRGWq__inclusionsGridWithTip",
  "inclusionsLabel": "HolidayDetail-module__MbRGWq__inclusionsLabel",
  "infoCard": "HolidayDetail-module__MbRGWq__infoCard",
  "itineraryDivider": "HolidayDetail-module__MbRGWq__itineraryDivider",
  "itineraryLine": "HolidayDetail-module__MbRGWq__itineraryLine",
  "itineraryNights": "HolidayDetail-module__MbRGWq__itineraryNights",
  "itinerarySegment": "HolidayDetail-module__MbRGWq__itinerarySegment",
  "listsize": "HolidayDetail-module__MbRGWq__listsize",
  "mainCol": "HolidayDetail-module__MbRGWq__mainCol",
  "mainTile": "HolidayDetail-module__MbRGWq__mainTile",
  "mediaCard": "HolidayDetail-module__MbRGWq__mediaCard",
  "mediaCardRow": "HolidayDetail-module__MbRGWq__mediaCardRow",
  "mediaIconCircle": "HolidayDetail-module__MbRGWq__mediaIconCircle",
  "mediaIconNeutral": "HolidayDetail-module__MbRGWq__mediaIconNeutral",
  "mediaText": "HolidayDetail-module__MbRGWq__mediaText",
  "metaRow": "HolidayDetail-module__MbRGWq__metaRow",
  "mobileActionCards": "HolidayDetail-module__MbRGWq__mobileActionCards",
  "mobileEnquiryBtn": "HolidayDetail-module__MbRGWq__mobileEnquiryBtn",
  "mobileInclusions": "HolidayDetail-module__MbRGWq__mobileInclusions",
  "mobilePriceActions": "HolidayDetail-module__MbRGWq__mobilePriceActions",
  "mobilePriceBar": "HolidayDetail-module__MbRGWq__mobilePriceBar",
  "mobilePriceBarHidden": "HolidayDetail-module__MbRGWq__mobilePriceBarHidden",
  "mobilePriceInfo": "HolidayDetail-module__MbRGWq__mobilePriceInfo",
  "mobilePriceNote": "HolidayDetail-module__MbRGWq__mobilePriceNote",
  "mobilePriceNow": "HolidayDetail-module__MbRGWq__mobilePriceNow",
  "mobilePriceOld": "HolidayDetail-module__MbRGWq__mobilePriceOld",
  "mobilePriceOldSpan": "HolidayDetail-module__MbRGWq__mobilePriceOldSpan",
  "mobileProceedBtn": "HolidayDetail-module__MbRGWq__mobileProceedBtn",
  "mobileTabLabel": "HolidayDetail-module__MbRGWq__mobileTabLabel",
  "offerTag": "HolidayDetail-module__MbRGWq__offerTag",
  "overviewHtml": "HolidayDetail-module__MbRGWq__overviewHtml",
  "overviewLabel": "HolidayDetail-module__MbRGWq__overviewLabel",
  "overviewText": "HolidayDetail-module__MbRGWq__overviewText",
  "packageDetailBadge": "HolidayDetail-module__MbRGWq__packageDetailBadge",
  "packageDetailBadgeImg": "HolidayDetail-module__MbRGWq__packageDetailBadgeImg",
  "packageHeader": "HolidayDetail-module__MbRGWq__packageHeader",
  "packageHeader2": "HolidayDetail-module__MbRGWq__packageHeader2",
  "page": "HolidayDetail-module__MbRGWq__page",
  "priceCard": "HolidayDetail-module__MbRGWq__priceCard",
  "priceNote": "HolidayDetail-module__MbRGWq__priceNote",
  "priceNow": "HolidayDetail-module__MbRGWq__priceNow",
  "priceOld": "HolidayDetail-module__MbRGWq__priceOld",
  "priceOldAmount": "HolidayDetail-module__MbRGWq__priceOldAmount",
  "priceRow": "HolidayDetail-module__MbRGWq__priceRow",
  "priceTop": "HolidayDetail-module__MbRGWq__priceTop",
  "proceedBtn": "HolidayDetail-module__MbRGWq__proceedBtn",
  "ratingBadge": "HolidayDetail-module__MbRGWq__ratingBadge",
  "readMore": "HolidayDetail-module__MbRGWq__readMore",
  "saveTag": "HolidayDetail-module__MbRGWq__saveTag",
  "sectionHeaderStatic": "HolidayDetail-module__MbRGWq__sectionHeaderStatic",
  "sectionTitle": "HolidayDetail-module__MbRGWq__sectionTitle",
  "sideTile": "HolidayDetail-module__MbRGWq__sideTile",
  "sidebar": "HolidayDetail-module__MbRGWq__sidebar",
  "stateMsg": "HolidayDetail-module__MbRGWq__stateMsg",
  "stickyPriceTitle": "HolidayDetail-module__MbRGWq__stickyPriceTitle",
  "tabButton": "HolidayDetail-module__MbRGWq__tabButton",
  "tabButtonActive": "HolidayDetail-module__MbRGWq__tabButtonActive",
  "tabContainer": "HolidayDetail-module__MbRGWq__tabContainer",
  "tabContainerSticky": "HolidayDetail-module__MbRGWq__tabContainerSticky",
  "tabPlaceholder": "HolidayDetail-module__MbRGWq__tabPlaceholder",
  "tabSentinel": "HolidayDetail-module__MbRGWq__tabSentinel",
  "tabStickyWrap": "HolidayDetail-module__MbRGWq__tabStickyWrap",
  "tile": "HolidayDetail-module__MbRGWq__tile",
  "title": "HolidayDetail-module__MbRGWq__title",
  "titleBlock": "HolidayDetail-module__MbRGWq__titleBlock",
  "titleLine": "HolidayDetail-module__MbRGWq__titleLine",
  "viewMoreBtn": "HolidayDetail-module__MbRGWq__viewMoreBtn",
});
